import Vue from 'vue';
import { TranslateResult } from 'vue-i18n';
import _ from 'lodash';

// Event bus para comunicación entre servicios y componentes
export const EventBus = new Vue();

// Tipos de notificaciones
export type NotificationType = 'success' | 'error' | 'info' | 'warning';

// Interfaz para las notificaciones
export interface Notification {
  type: NotificationType;
  message: string;
  title?: string;
  options?: any;
}

/**
 * Servicio para mostrar notificaciones desde cualquier parte de la aplicación,
 * incluyendo servicios que no tienen acceso directo a la instancia de Vue
 */
class ToastService {
  /**
   * Muestra una notificación toast
   */
  showToast(notification: Notification): void {
    EventBus.$emit('show-toast', notification);
  }

  /**
   * Muestra un mensaje de éxito
   */
  success(message: string | TranslateResult, title?: string, options?: any): void {
    this.showToast({
      type: 'success',
      message: message.toString(),
      title,
      options
    });
  }

  /**
   * Muestra un mensaje de error
   */
  error(message: string | TranslateResult, title?: string, options?: any): void {
    this.showToast({
      type: 'error',
      message: message.toString(),
      title,
      options
    });
  }

  /**
   * Muestra un mensaje informativo
   */
  info(message: string | TranslateResult, title?: string, options?: any): void {
    this.showToast({
      type: 'info',
      message: message.toString(),
      title,
      options
    });
  }

  /**
   * Muestra un mensaje de advertencia
   */
  warning(message: string | TranslateResult, title?: string, options?: any): void {
    this.showToast({
      type: 'warning',
      message: message.toString(),
      title,
      options
    });
  }
}

export default new ToastService();